import { useState } from 'react';
import { faqs } from '@/mocks/site';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-16">
        <div>
          <p className="text-xs font-medium tracking-[0.2em] text-primary-700">常见问题</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            读者问得最多的几件事
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            没找到答案？可以直接写信给我们，我们会在核实后回复或整理成新的问答。
          </p>
          <a
            href="mailto:report@heiliaoleida.com"
            className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-600 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-secondary-700"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-mail-line text-sm"></i>
            </span>
            发邮件提问
          </a>
        </div>

        <ul className="divide-y divide-background-200 border-y border-background-200">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <li key={faq.question}>
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-start justify-between gap-4 py-4 text-left"
                  >
                    <span
                      className={`text-sm font-medium leading-6 transition-colors md:text-base ${
                        isOpen ? 'text-primary-700' : 'text-foreground-900'
                      }`}
                    >
                      {faq.question}
                    </span>
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors ${
                        isOpen
                          ? 'border-primary-300 bg-primary-100 text-primary-700'
                          : 'border-background-300 text-foreground-600'
                      }`}
                    >
                      <i className={isOpen ? 'ri-subtract-line text-sm' : 'ri-add-line text-sm'}></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <p className="pb-5 pr-10 text-sm leading-7 text-foreground-600">{faq.answer}</p>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}